import moment from 'moment'
import {apiSaveFile} from '../app/redux/api'
import {toast} from 'react-toastify'
import * as devices from '../app/redux/DevicesRedux'
import { timeCounter } from './timeCounter'

function base64ToFile(base64String: string, fileName: string, mimeType: string): File {
  const base64Data = base64String.replace(/^data:.+;base64,/, '')
  const byteCharacters = atob(base64Data)
  const byteNumbers = new Array(byteCharacters.length)

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }

  const byteArray = new Uint8Array(byteNumbers)
  return new File([byteArray], fileName, {type: mimeType})
}

export const saveSnapshot = (
  selectedDevice: any,
  imageSrcs: string[],
  intl: any,
  fileSizeInBytes: any,
  formatSanpshotResponseTime:any
) => {
  const momentObject = moment()
  const startEpoch = momentObject.unix()
  const date = momentObject.format('YYMMDD')
  const time = momentObject.format('HHmmss')

  const latRaw = selectedDevice.GpsTbl[1].toString()
  const longRaw = selectedDevice.GpsTbl[2].toString()

  let lat, long

  if (latRaw && longRaw && latRaw !== '0' && longRaw !== '0') {
    lat = parseFloat(latRaw.slice(0, -4) + '.' + latRaw.slice(-4)).toFixed(4)
    long = parseFloat(longRaw.slice(0, -4) + '.' + longRaw.slice(-4)).toFixed(4)
  }

  const bodyString: any = {
    title: `Snapshot auto-save, vehicle: ${selectedDevice.VehicleNo}`,
    deviceId: selectedDevice.DeviceId,
    startEpoch: startEpoch,
    endEpoch: startEpoch,
    ...(lat && long ? {startLat: lat, startLong: long} : {}),
    comment: 'Saved by FE',
    extension: '.jpg',
    fileSize: fileSizeInBytes,
    downloadDuration:formatSanpshotResponseTime
  }
  


  const fileObjects: File[] = imageSrcs.map((base64: string, index: number) => {
    const fileName =
      imageSrcs.length === 1 || index === 0
        ? `Snapshot-${selectedDevice.DeviceId}-${date}-${time}-${startEpoch}.jpg`
        : `Snapshot${index}-${selectedDevice.DeviceId}-${date}-${time}-${startEpoch}.jpg`
    const mimeType = 'image/jpg'
    return base64ToFile(base64, fileName, mimeType)
  })

  apiSaveFile({bodyString: JSON.stringify(bodyString)}, fileObjects)
    .then(({data}: any) => {
      if (data.status === 200 && data.message.toLowerCase() === 'success') {
        toast.success(intl.formatMessage({id: 'TOAST.SNAPSHOT_SAVED_SUCCESSFULLY'}))
      } else {
        toast.error(intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_SAVING_SNAPSHORT'}))
      }
     timeCounter.reset();
    })
    .catch((error) => {
      toast.error(intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_SAVING_SNAPSHORT'}))
      timeCounter.reset();
    })
}

const extractExtension = (url: string) => {
  try {
    const pathname = url
    const lastSegment = pathname.substring(pathname.lastIndexOf('/') + 1)
    const dotIndex = lastSegment.lastIndexOf('.')
    return dotIndex !== -1 ? lastSegment.substring(dotIndex) : ''
  } catch {
    return null
  }
}

async function getVideoFileSize(url: any) {
  try {
    const response = await fetch(url, {method: 'HEAD'})

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const contentLength = response.headers.get('Content-Length')

    if (contentLength) {
      return contentLength ? parseInt(contentLength, 10) : null
    }
  } catch (error) {
    console.error('Error fetching video size:', error)
  }
}

export const saveVideo = async (
  videodata: any,
  intl: any,
  dispatch: any,
  selectedDeviceInfo: any,
  formatVideoResponseTime:any
) => {
  const [datePart, timeRange] = selectedDeviceInfo.TimeRange.split('|').map((s: any) => s.trim())
  const [startTime, endTime] = timeRange.split('-').map((s: any) => s.trim())
  const startEpoch = moment(`${datePart} ${startTime}`, 'YYYY-MM-DD HH:mm:ss').unix()
  const endEpoch = moment(`${datePart} ${endTime}`, 'YYYY-MM-DD HH:mm:ss').unix()
  const fileSizeInBytes = await getVideoFileSize(`https://cdn.vehiclets.com:440/${videodata.FileName}`)
  const bodyString: any = {
    urlProvided: true,
    title: `Video auto-save, vehicle: ${selectedDeviceInfo.VehicleNo}`,
    deviceId: videodata.DeviceId,
    fileUrl: videodata.FileName,
    startEpoch: startEpoch,
    endEpoch: endEpoch,
    extension: extractExtension(videodata.FileName),
    comment: 'GetRecordVideo File downloaded',
    fileSize: fileSizeInBytes ?? 0,
    downloadDuration:formatVideoResponseTime
  }

  apiSaveFile({bodyString: JSON.stringify(bodyString)})
    .then(({data}: any) => {
      if (data.status === 200 && data.message.toLowerCase() === 'success') {
        toast.success(intl.formatMessage({id: 'TOAST.VIDEO_SAVED_SUCCESSFULLY'}))
        dispatch(
          devices.actions.setSelectedDevice({...selectedDeviceInfo, fileId: data.response.fileId})
        )
      } else {
        toast.error(
          `${intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_SAVING_VIDEO'})} : ${data.message}`
        )
      }
    timeCounter.reset();
    })
    .catch((error) => {
      toast.error(intl.formatMessage({id: 'TOAST.ERROR_OCCURRED_WHILE_SAVING_VIDEO'}))
      timeCounter.reset();
    })
}



